import type { FetchConfig } from "./types";

export function buildFetch(flux: FetchConfig[]) {
  return flux.reduce((nextFetch, config) => {
    return config(nextFetch)
  }, fetch)
}
